import { jsx } from 'react/jsx-runtime';

/**
 * Riga di una `Table`.
 */
function BodyRow({ children = null }) {
    return (jsx("tr", { children: children }));
}

export { BodyRow as default };
